<template>
    <component :is="SkinComponent" v-model="user" :areas="areas_structured" @submit="submit"></component>
</template>

<script>
import api from "@/api";
import CryptoAES from "@/plugins/crypto-aes";
import { USER_TYPES } from "@/assets/variables";
import { mapActions } from "vuex";

export default {
    props: ["skin", "code"],
    data() {
        return {
            user: {
                _terms: this.$store.state.agreements || [],

                type: this.$props.code || USER_TYPES.INDIVIDUAL,

                username: null,
                password: null,
                passwordConfirm: null,

                name: null,

                phone: null,
                phone1: "010",
                phone2: null,
                phone3: null,

                email: null,
                email1: null,
                email2: null,
                email3: null,

                postcode: null,
                address1: null,
                address2: null,

                _areas: [],
                areas_manual: {},

                meta: {},
            },
            areas: [],
        };
    },
    computed: {
        SkinComponent() {
            return () => import(`./skin/${this.$props.skin}/form.vue`);
        },
        areas_structured() {
            const parents = (this.areas || []).filter(({ _parent }) => !_parent).sort((a, b) => a.order - b.order);
            const areas = parents.map((parent) => ({
                ...parent,
                children: (this.areas || []).filter(({ _parent }) => _parent == parent._id).sort((a, b) => a.order - b.order),
            }));
            return areas;
        },
    },
    mounted() {
        this.init();
    },
    methods: {
        ...mapActions(["login"]),

        async init() {
            var { areas } = await api.v1.areas.gets();
            this.areas = areas;
        },

        async submit() {
            try {
                const areas_manual = this.user.areas_manual ? Object.keys(this.user.areas_manual || {}).map((_parent) => ({ _parent, name: this.user.areas_manual[_parent] })) : undefined;

                var { user } = await api.v1.users.post({
                    ...this.user,
                    password: CryptoAES.encrypt(this.user.password),
                    passwordConfirm: null,
                    residentNumber: this.user.residentNumber ? CryptoAES.encrypt(this.user.residentNumber) : undefined,
                    areas_manual,
                    brochures: undefined,
                });

                if (this.user?.avatar) {
                    await api.v1.users.avatar.post({ _user: user._id }, this.user.avatar);
                }

                if (this.user?.brochures?.length) {
                    for (const [index, brochure] of this.user.brochures.entries()) {
                        await api.v1.users.brochures.post({ _user: user._id, index }, brochure);
                    }
                }

                let { username, password, type, kind } = this.user || {};
                await this.login({ username, password });

                let query = { type, kind };
                if (!type) delete query.type;
                if (!kind) delete query.kind;

                this.$router.push({ path: "/join/complete", query });
            } catch (error) {
                this.$handleError(error);
            }
        },
    },
};
</script>
